
import { Product } from "@/types/product";

export const softwareProducts: Product[] = [
  {
    id: "reax-core-studio",
    groupId: "reax-software",
    name: "ReAX Core Studio",
    description: "ReAX Core Studio is Aurora's professional control system development software, designed to make system programming both powerful and accessible. Its flow-based programming interface features an extensive library of drag-and-drop functions, allowing for intuitive creation of sophisticated control solutions.\n\nThe software includes an integrated AI assistant that provides real-time help with JavaScript coding, troubleshooting, and system design. This AI-powered feature significantly accelerates development time and makes programming accessible even to those with limited coding experience.\n\nCore Studio's comprehensive project management tools include real-time debugging capabilities, dynamic variable monitoring, and source control integration. The software supports simultaneous connections to multiple devices, enabling efficient programming and testing across complex installations. The interface features a visual node-based editor alongside traditional coding tools, giving integrators the flexibility to work in their preferred style.",
    features: [
      "Flow-based programming interface",
      "Integrated AI assistant for coding help",
      "Extensive drag-and-drop function library",
      "Visual node-based programming",
      "Real-time debugging with PC connection",
      "Project file/memory management",
      "Dynamic variable monitoring",
      "Built-in help system",
      "Source control integration",
      "Project packager",
      "Offline programming capabilities",
      "Multiple simultaneous device connections",
      "Touch panel interface designer",
      "Device driver library",
      "Free software updates"
    ],
    specifications: [
      "Operating System: Windows 10/11",
      "Minimum RAM: 8GB recommended",
      "Processor: Intel i5 or better",
      "Hard Drive: 500MB free space",
      "Network: Required for device communication",
      "Display: 1920x1080 minimum resolution",
      "USB: Required for direct device connection",
      "Internet: Required for updates and AI features"
    ],
    images: [
      "/lovable-uploads/1f12f184-1a1c-48ea-bf40-59ff42404b0c.png",
      "/lovable-uploads/d27497b6-6395-4396-b40b-5230f9ba9858.png",
      "/lovable-uploads/4965796f-00fb-4c83-8d4c-5647bb8177fe.png"
    ],
    image: "/lovable-uploads/1f12f184-1a1c-48ea-bf40-59ff42404b0c.png",
    videoUrl: "https://youtu.be/aMzuV58I6kI?si=hWN-3HQ743hgj0Q_",
    slug: "reax-core-studio"
  }
];

export const accessoryProducts: Product[] = [
  {
    id: "lxc-1",
    groupId: "reax-accessories",
    name: "LXC-1",
    description: "The LXC-1 is a versatile dual relay and I/O control module designed for streamlined integration with ReAX control systems. This compact device provides professional-grade control capabilities with multiple interface options including LAN, RS-232, and IR control.\n\nThe LXC-1 features dual relay ports for controlling external devices, dual I/O ports for sensing and controlling additional equipment, and comprehensive status indicators for real-time operational feedback. Its PoE capability eliminates the need for separate power supplies, further simplifying installation.\n\nWith its compact form factor and rack-mountable design, the LXC-1 is ideal for both commercial and residential installations where reliable device control is essential. The device integrates seamlessly with Aurora's ReAX control platform, enabling sophisticated automation scenarios through simple programming.",
    features: [
      "Dual Relay Control Ports",
      "Dual I/O Control Ports",
      "LAN Interface with PoE",
      "RS-232 Control Interface",
      "IR Control and Distribution",
      "Status Indicator LEDs",
      "Compact 1/3 Rack Width Design",
      "ReAX Control System Integration",
      "Versatile Mounting Options",
      "Web Configuration Interface"
    ],
    specifications: [
      "Control Interfaces: LAN (PoE), RS-232, IR",
      "Relay Ports: 2 (NC/NO/Common)",
      "I/O Ports: 2 (Digital/Analog)",
      "LAN: RJ-45 10/100 Ethernet",
      "Power: 48V DC or PoE (802.3af)",
      "Dimensions: 1.75\" x 5.8\" x 5.0\"",
      "Mounting: Rack, Surface, or Freestanding",
      "Operating Temperature: 0-40°C",
      "Warranty: 3 Years"
    ],
    images: [
      "/lovable-uploads/4d2d847f-cdc2-4e60-8911-5dcdf710a78b.png",
      "/lovable-uploads/0bdbb85f-eb61-4f81-9812-b9f010c32eb8.png"
    ],
    image: "/lovable-uploads/4d2d847f-cdc2-4e60-8911-5dcdf710a78b.png",
    slug: "lxc-1"
  }
];

export const softwareAndAccessoryProducts: Product[] = [
  ...softwareProducts,
  ...accessoryProducts
];
